import { render, staticRenderFns } from "./screenMap.vue?vue&type=template&id=032bcd08&"
import script from "./screenMap.vue?vue&type=script&lang=js&"
export * from "./screenMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports